module.exports = __webpack_public_path__ + "img/component-settings-dark-01.5e40a342.jpg";